import { render, staticRenderFns } from "./singleChoice.vue?vue&type=template&id=3f477ab2&scoped=true"
import script from "./singleChoice.vue?vue&type=script&lang=js"
export * from "./singleChoice.vue?vue&type=script&lang=js"
import style0 from "./singleChoice.vue?vue&type=style&index=0&id=3f477ab2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f477ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f477ab2')) {
      api.createRecord('3f477ab2', component.options)
    } else {
      api.reload('3f477ab2', component.options)
    }
    module.hot.accept("./singleChoice.vue?vue&type=template&id=3f477ab2&scoped=true", function () {
      api.rerender('3f477ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/testquestion-manage/singleChoice.vue"
export default component.exports